import { Check } from 'lucide-react';
import { useState } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../components/ui/popover';
import { Button } from '../../../components/ui/button';
import { cn } from '../../../lib/utils';
import { type SearchMode } from './types';

type SearchModePopoverProps = {
  setSearchMode: (mode: Pick<SearchMode, 'mode'>['mode']) => void;
  searchMode: Pick<SearchMode, 'mode'>['mode'];
  searchModes: SearchMode[];
};

export const SearchModePopover = ({
  setSearchMode,
  searchMode,
  searchModes,
}: SearchModePopoverProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        render={
          <Button
            type="button"
            variant="secondary"
            size="sm"
            className="absolute top-1/2 left-1 -translate-y-1/2 rounded-sm px-2 capitalize"
          />
        }
      >
        {searchMode}
      </PopoverTrigger>
      <PopoverContent align="start" className="w-60 p-1">
        {searchModes.map((sM) => {
          const isSelected = searchMode === sM.mode;
          return (
            <button
              type="button"
              key={sM.mode}
              className={cn(
                'flex w-full items-center gap-2 rounded-sm border-l-4 px-2 py-2 text-left transition-colors hover:bg-muted',
                isSelected
                  ? 'border-l-primary bg-muted'
                  : 'border-l-transparent'
              )}
              onClick={() => {
                setSearchMode(sM.mode);
                setOpen(false);
              }}
            >
              <span className="flex-1">
                <span className="block text-sm font-medium capitalize text-primary">
                  {sM.mode}
                </span>
                <span className="block text-xs text-muted-foreground">
                  {sM.label}
                </span>
              </span>
              {isSelected && <Check className="size-4 text-primary" />}
            </button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
};
